import { render, staticRenderFns } from "./AdditionalParamsCard.vue?vue&type=template&id=6e6f407f&"
import script from "./AdditionalParamsCard.vue?vue&type=script&lang=ts&"
export * from "./AdditionalParamsCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports